import register from 'preact-custom-element';

import DiscoverRolexPage      from '../src/pages/DiscoverRolex/index.jsx';
import RolexWatchesPage       from '../src/pages/RolexWatches/index.jsx';
import NewWatches2024Page     from '../src/pages/NewWatches2024/index.jsx';
import WatchmakingPage        from '../src/pages/Watchmaking/index.jsx';
import ServicingPage          from '../src/pages/Servicing/index.jsx';
import ServicingProcedurePage from '../src/pages/ServicingProcedure/index.jsx';
import WorldOfRolexPage       from '../src/pages/WorldOfRolex/index.jsx';
import ContactPage            from '../src/pages/Contact/index.jsx';
import SendMessagePage        from '../src/pages/Contact/send-message.jsx';
import { App }                from '../src/index.jsx';

register(App, 'rlx-app', ['apikey', 'pathroot', 'enableanalytics', 'privacylink'], { shadow: true });
// register(DiscoverRolexPage, 'rlx-discover-rolex-page', ['apikey'], { shadow: true });
// register(RolexWatchesPage, 'rlx-watches-page', ['apikey'], { shadow: true });
// register(NewWatches2024Page, 'rlx-new-watches-2024-page', ['apikey'], { shadow: true });
// register(WatchmakingPage, 'rlx-watchmaking-page', ['apikey'], { shadow: true });
// register(ServicingPage, 'rlx-servicing-page', ['apikey'], { shadow: true });
// register(ServicingProcedurePage, 'rlx-servicing-procedure-page', ['apikey'], { shadow: true });
// register(WorldOfRolexPage, 'rlx-world-of-rolex-page', ['apikey'], { shadow: true });
// register(ContactPage, 'rlx-contact-page', ['apikey'], { shadow: true });
// register(SendMessagePage, 'rlx-send-message-page', ['apikey'], { shadow: true });
